import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileManagerComponent } from './file-manager.component';
import { FileListComponent } from './file-list/file-list.component';
import { FolderTreeComponent } from './folder-tree/folder-tree.component';
import { SharedModule } from '../shared.module';

@NgModule({
  declarations: [FileManagerComponent, FileListComponent, FolderTreeComponent],
  imports: [CommonModule, SharedModule],
  exports: [FileManagerComponent]
})
export class FileManagerModule {}
